// extracted by mini-css-extract-plugin
module.exports = {"flex":"styles_flex__2Zgol","data":"styles_data__yP-ZP","title":"styles_title__54eDU","value":"styles_value__30waT"};